// store/search/searchUsers.slice.ts
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchUsersApi } from "apis/UserServiceApi";

interface SearchState {
  loading: boolean;
  results: SearchUserResult[];
  error: string | null;
}

const initialState: SearchState = { loading: false, results: [], error: null };

export const fetchUsers = createAsyncThunk(
  "searchUsers/fetch",
  async (searchText: string, { rejectWithValue }) => {
    try {
      const res = await searchUsersApi(searchText); // POST { searchText }
      return res.data as SearchUserResult[];
    } catch (err: any) {
      return rejectWithValue(err.message ?? "Error al buscar usuarios");
    }
  }
);

const slice = createSlice({
  name: "searchUsers",
  initialState,
  reducers: {
    clearResults: (state) => void (state.results = []),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (st) => {
        st.loading = true;
        st.error = null;
      })
      .addCase(fetchUsers.fulfilled, (st, { payload }) => {
        st.loading = false;
        st.results = payload;
      })
      .addCase(fetchUsers.rejected, (st, { payload }) => {
        st.loading = false;
        st.error = payload as string;
      });
  },
});

export const { clearResults } = slice.actions;
export const searchUsersReducer = slice.reducer;
